import { Modal, Avatar, Checkbox, List, Space } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { ACheckbox } from 'components/Antd';
import AvatarPlaceholder from 'assets/img/company-logo-placeholder.png';
import get from 'lodash/get';

const Title = styled.h3`
  color: #0c91c4;
  text-align: center;
  font-family: Roboto;
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.36px;
`;
const Description = styled.p`
  color: var(--text-text-600, #232b3a);
  text-align: center;

  /* Body/Body 2 - Regular */
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
  letter-spacing: 0.028px;
`;

const Wrapper = styled(Space)`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  > div {
    text-align: center;
  }
`;

const ListItem = styled(List.Item)`
  text-align: left;
  .ant-list-item-meta-title {
    color: var(--text-text-500, #3a4861);

    /* Body/Body 3 - Regular */
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
    letter-spacing: 0.06px;
  }
  .ant-list-item-meta-description {
    color: var(--text-text-300, #8991a0);

    /* Body/Body 3 - Regular */
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 133.333% */
    letter-spacing: 0.06px;
  }
`;

const StyledList = styled(List)`
  width: 410px;
  /* min-height: 350px; */
  max-height: 220px;
  overflow: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

const StyledModal = styled(Modal)`
  .ant-modal-footer {
    text-align: left;
  }
`;

const ModalInvitations = ({ open, onClose, loading, data, fetch, acceptInvitation }) => {
  const [selected, setSelected] = React.useState([]);
  const [confirmLoading, setConfirmLoading] = React.useState(false);
  const accept = async () => {
    return acceptInvitation(selected);
    // await Promise.all(
    //   selected.map(async (code) => {
    //     return acceptInvitation(code);
    //   })
    // );
  };
  const onSubmit = async () => {
    setConfirmLoading(true);
    await accept();
    setConfirmLoading(false);
    onClose();
  };
  const renderItem = (supplier) => {
    return (
      <ListItem
        aria-disabled={!supplier.email}
        onClick={(e) => {
          if (!supplier.email) return;
          e.currentTarget.getElementsByClassName('ant-checkbox-input')[0].click();
        }}
        extra={<ACheckbox value={supplier.code} />}>
        <List.Item.Meta
          avatar={
            <Avatar size="large" src={get(supplier, 'companyLogo.url') || AvatarPlaceholder} />
          }
          title={supplier.creatorCompanyName}
          description="Collaborator"
        />
      </ListItem>
    );
  };

  React.useEffect(() => {
    // if (open) {
    //   fetch();
    // }
  }, [open]);

  return (
    <StyledModal
      open={open}
      confirmLoading={confirmLoading}
      okText="Accept"
      okButtonProps={{ disabled: selected.length === 0 }}
      cancelButtonProps={{ hidden: true }}
      onOk={() => {
        onSubmit();
      }}
      onCancel={() => {
        onClose();
      }}>
      <Wrapper direction="vertical" size={32}>
        <Title>Accept Buyer Invitation</Title>
        <Description>Select the company you would like to connect with.</Description>
        <Checkbox.Group
          value={selected}
          onChange={(selectedInvitation) => {
            setSelected(selectedInvitation);
          }}>
          <StyledList loading={loading} dataSource={data} renderItem={renderItem} />
        </Checkbox.Group>
      </Wrapper>
    </StyledModal>
  );
};

export default ModalInvitations;
